import ChatLayout from "components/layouts/ChatLayout";
import LoadingLayout from "components/layouts/LoadingLayout";
import Mypage1CLayout from "components/layouts/Mypage1CLayout";
import Mypage2CLayout from "components/layouts/Mypage2CLayout";
import CandidateCorpPage from "pages/candidate/CandidateCorpPage";
import CandidateItemPage from "pages/candidate/CandidateItemPage";
import CategoryCorpPage from "pages/category/CategoryCorpPage";
import CategoryItemPage from "pages/category/CategoryItemPage";
import CorpDetailPage from "pages/corp/CorpDetailPage";
import CorpInfoPage from "pages/corp/CorpInfoPage";
import CorpListPage from "pages/corp/CorpListPage";
import CorpProfileEditPage from "pages/corp/CorpProfileEditPage";
import DevLoginPage from "pages/dev/DevLoginPage";
import E404 from "pages/errors/E404";
import ErrorAuth from "pages/errors/ErrorAuth";
import ExhibitEntryPage from "pages/exhibit/ExhibitEntryPage";
import ExhibitListPage from "pages/exhibit/ExhibitListPage";
import FavoriteCorpPage from "pages/favorite/FavoriteCorpPage";
import FavoriteItemPage from "pages/favorite/FavoriteItemPage";
import ItemDetailPage from "pages/item/ItemDetailPage";
import ItemListPage from "pages/item/ItemListPage";
import HideListDetailPage from "pages/list/HideListDetailPage";
import HideListPage from "pages/list/HideListPage";
import LimitedListDetailPage from "pages/list/LimitedListDetailPage";
import LimitedListPage from "pages/list/LimitedListPage";
import Mypage from "pages/Mypage";
import CorpEntryCompletePage from "pages/public/CorpEntryCompletePage";
import CorpEntryPage from "pages/public/CorpEntryPage";
import CorpRegisterPage from "pages/public/CorpRegisterPage";
import ExistingClientsPage from "pages/public/ExistingClientsPage";
import LoginRedirectPage from "pages/public/LoginRedirectPage";
import TermsOfServicePage from "pages/public/TermsOfServicePage";
import TopPage from "pages/public/TopPage";
import TalkListPage from "pages/thread/TalkListPage";
import ThreadAdminListPage from "pages/thread/ThreadAdminListPage";
import ThreadDetailPage from "pages/thread/ThreadDetailPage";
import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

const App: React.FC = () => {
  
  return (
    <BrowserRouter basename="web.d">
      <Routes>
        {/* デバッグ用の画面 - ここから */}
        {process.env.NODE_ENV === "development" && (
          <>
            <Route path="/" element={<TopPage />} />
            <Route path="/dev" element={<LoadingLayout />}>
              <Route path="login" element={<DevLoginPage />} />
            </Route>
          </>
        )}
        {process.env.NODE_ENV !== "development" && <Route path="/" element={<E404 />} />}
        {/* デバッグ用の画面 - ここまで */}

        {/* ログイン */}
        <Route path="login-redirect" element={<LoginRedirectPage />} />

        <Route path="/" element={<LoadingLayout />}>
          {/* 会社登録(メールアドレスの登録,送信) */}
          <Route path="company-register" element={<CorpRegisterPage />} />
          {/* 利用規約画面 */}
          <Route path="terms-of-service" element={<TermsOfServicePage />} />
          {/* 既存取引先画面 */}
          <Route path="existing-clients" element={<ExistingClientsPage />} />
          {/* 会社登録申請 */}
          <Route path="company-entry-apply" element={<CorpEntryPage />} />
          {/* 会社登録申請 完了 */}
          <Route
            path="company-entry-apply-finish"
            element={<CorpEntryCompletePage />}
          />
        </Route>

        <Route path="/" element={<Mypage2CLayout />}>
          {/* マイページトップ */}
          <Route path="mypage" element={<Mypage />} />
          {/* 出品一覧 */}
          <Route path="exhibit-list" element={<ExhibitListPage />} />
          {/* 非公開リスト */}
          <Route path="non-disclosure-list" element={<HideListPage />} />
          <Route
            path="non-disclosure-detail"
            element={<HideListDetailPage />}
          />
          <Route
            path="non-disclosure-detail/:id"
            element={<HideListDetailPage />}
          />
          {/* 限定公開リスト */}
          <Route path="limited-disclosure-list" element={<LimitedListPage />} />
          <Route
            path="limited-disclosure-detail"
            element={<LimitedListDetailPage />}
          />
          <Route
            path="limited-disclosure-detail/:id"
            element={<LimitedListDetailPage />}
          />
          {/* お気に入り会社一覧 */}
          <Route path="favorite-company" element={<FavoriteCorpPage />} />
          {/* お気に入り商品一覧 */}
          <Route path="favorite-item" element={<FavoriteItemPage />} />
          {/* 見積依頼・お問い合わせ一覧 */}
          <Route path="talk-list" element={<TalkListPage />} />
          {/* 掲示板管理 */}
          <Route path="thread-list" element={<ThreadAdminListPage />} />
        </Route>

        <Route path="/" element={<Mypage1CLayout />}>
          {/* 商品一覧 */}
          <Route path="item-list" element={<ItemListPage />} />
          {/* 商品詳細 */}
          <Route path="item-detail/:item_cd" element={<ItemDetailPage />} />
          {/* 会社一覧 */}
          <Route path="company-list" element={<CorpListPage />} />
          {/* 会社詳細 */}
          <Route path="company-detail/:id" element={<CorpDetailPage />} />
          {/* 商談候補会社 */}
          <Route path="candidate-company" element={<CandidateCorpPage />} />
          {/* 商談候補商品 */}
          <Route path="candidate-item" element={<CandidateItemPage />} />

          {/* 会社情報設定 */}
          <Route path="company-info" element={<CorpInfoPage />} />
          {/* 会社PR設定 */}
          <Route path="public-relations" element={<CorpProfileEditPage />} />
          {/* 出品登録 */}
          <Route path="exhibit-entry" element={<ExhibitEntryPage />} />
          <Route path="exhibit-entry/:item_cd" element={<ExhibitEntryPage />} />
        </Route>

        <Route path="/" element={<ChatLayout />}>
          {/* 見積依頼・お問い合わせ詳細 */}
          <Route path="talk-detail/:id" element={<ThreadDetailPage />} />
          {/* 会社カテゴリ設定 */}
          <Route path="company-category" element={<CategoryCorpPage />} />
          {/* 商品カテゴリ設定 */}
          <Route path="item-category" element={<CategoryItemPage />} />
        </Route>

        <Route path="auth-error" element={<ErrorAuth />} />

        <Route path="*" element={<E404 />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
